import { render } from "./anc_present_pregnancy.vue?vue&type=template&id=23dcbab7&scoped=true"
import script from "./anc_present_pregnancy.vue?vue&type=script&lang=js"
export * from "./anc_present_pregnancy.vue?vue&type=script&lang=js"

import "./anc_present_pregnancy.vue?vue&type=style&index=0&id=23dcbab7&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dcbab7"]])

export default __exports__